import { Injectable } from '@angular/core';

import { MeasureInputService } from './measure-input.service';
import { MeasureContext } from '../models/models';


@Injectable()
export class MeasureContextService {
  measureContext: MeasureContext;

  constructor(private measureInputService: MeasureInputService) {
    this.measureContext = MeasureInputService.getMeasureContext();
  }

  adjustLocation() {
    this.measureInputService.updateMeasureContext(this.measureContext
      .setLocationConfirmed(false));
  }

  adjustMeasure() {
    this.measureInputService.updateMeasureContext(this.measureContext
      .setRegistered(false));
  }

  confirmLocation() {
    this.measureInputService.updateMeasureContext(this.measureContext
      .setLocationConfirmed(true));
  }

  prepareForNewMeasure() {
    this.measureInputService.updateMeasureContext(this.measureContext
      .setLocationConfirmed(false)
      .setRegistered(false));
  }

  register() {
    this.measureInputService.updateMeasureContext(this.measureContext
      .setRegistered(true));
  }

  reset(): void {
    this.measureContext = new MeasureContext();
  }

  undoNavigation() {
    this.measureInputService.updateMeasureContext(this.measureContext
      .setLocationConfirmed(true)
      .setRegistered(true));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/measure-context.service.ts